<template>
  <a-menu-item :key="routeChildren.path" @click.capture="handleLink">
    <template #icon>
      <hhxc-icon :icon="routeChildren.meta.icon"></hhxc-icon>
    </template>
    {{ routeChildren.meta.title.split('-')[0] }}
  </a-menu-item>
</template>

<script>
  import HhxcIcon from '@/layout/hhxc-icon'
  import { isExternal } from '@/utils/validate'
  import { useRoute, useRouter } from 'vue-router'
  export default {
    name: 'MenuItem',
    components: { HhxcIcon },
    props: {
      item: {
        type: Object,
        default() {
          return { name: '' }
        },
      },
      routeChildren: {
        type: Object,
        default: () => null,
      },
    },
    setup(props) {
      const router = useRouter()
      const route = useRoute()
      const handleLink = () => {
        const routePath = props.routeChildren.path
        const target = props.routeChildren.meta.target
        if (target === '_blank') {
          if (isExternal(routePath)) window.open(routePath)
          else if (route.path !== routePath) window.open(routePath.href)
        } else {
          if (isExternal(routePath)) window.location.href = routePath
          else if (route.path !== routePath) router.push(routePath)
        }
      }
      return {
        handleLink,
      }
    },
  }
</script>
